import { ChangeEvent, FC, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { GET_PARAMS, GET_POPUPS } from "../const/router";
import { validate, validateEmail, VALIDATOR_EMAIL, VALIDATOR_REQUIRE } from '../helpers/Validators';
import usePrepareLink from "../hooks/usePrepareLink";
import { RootState } from "../redux/store";
import { checkCurrentMemberPassword, emailIsExistsInSystem } from "../services/accountService";


export type EditEmailProps = {
    onSave: (email: string) => void;
    value: string | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    buttonText: string;
    isEditMode: boolean;
}

const EditEmail: FC<EditEmailProps> = ({ isEditMode, onSave, value, title, subtitle, buttonText }) => {
    const [email, setEmail] = useState<string>("");
    const [validateEmail, setValidateEmail] = useState<string>("");
    const [currentPassword, setCurrentPassword] = useState<string>("");
    const [errors, setErrors] = useState<any>([]);
    const member = useSelector((state: RootState) => state.member);



    const validateForm = () => {
        let errors: any = {};
        if (!validate(email, [VALIDATOR_REQUIRE()])) {
            errors["email"] = "חובה להזין דואר אלקטרוני";
        }
        if (!validate(currentPassword, [VALIDATOR_REQUIRE()])) {
            errors["currentPassword"] = "חובה להזין סיסמה נוכחית";
        }
        if (!validate(email, [VALIDATOR_EMAIL()])) {
            errors["email"] = "כתובת המייל שהקלדת שגויה, שננסה שוב?";
        }
        if (email !== validateEmail) {
            errors["email"] = "כתובות דואר אלקטרוני לא תואמות";
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const validateWithServer = async () => {
        const { data: passwordCorrect } = await checkCurrentMemberPassword({ memberCode: member.memberCode, password: currentPassword });
        if (!passwordCorrect) {
            errors["currentPassword"] = "הסיסמה שהקלדת לא תואמת לסיסמה שלך. שננסה שוב?";
            setErrors(errors);
            return false;
        }
        else {
            const { data: emailCorrect } = await emailIsExistsInSystem(email);
            if (emailCorrect) {
                errors["email"] = "האיימיל בשימוש, אנא בחרו כתובת אימייל אחרת";
                setErrors(errors);
                return false;
            }
        }
        return true;
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (validateForm()) {
            if (await validateWithServer()) {
                onSave(email);
            }
        }
    };

    const link = usePrepareLink({
        state: {
            navigateFromProfile: true
        },
        pushToQuery: {
            [GET_PARAMS.popup]: GET_POPUPS.popup.findYourAccount,
        },
        keepOldQuery: true,
    });


    const enabled =
        email.length > 0 && currentPassword.length > 0;

    return (
        <>
            <div className="content_sec wf-section">

                <div className="signup_top_info">
                    <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                    <h2 className="signup_title">{title}</h2>
                    <div>{subtitle}</div>
                </div>
                <div className="login_sec w-form">
                    <form onSubmit={handleSubmit}>
                        <div className="form_field_content login">
                            <div style={{ paddingBottom: 5 }} className="field_block"><label htmlFor="email">סיסמה נוכחית</label>
                                <input autoComplete="off" name="password" type="password" value={currentPassword} onChange={e => {
                                    setErrors({})
                                    setCurrentPassword(e.target.value)
                                }} maxLength={256} className="txt_field password w-input" />
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div className="form_allert" style={{ display: errors && errors["currentPassword"] ? "contents" : "block" }}>{errors["currentPassword"]}</div>
                                    <Link to={link} className="forgot_link">
                                        שכחתי סיסמה
                                    </Link>
                                </div>
                            </div>
                            <div className="field_block">
                                <label htmlFor="name">הקלדת כתובת מייל חדשה</label>
                                <input autoComplete="off" name="email" type="text" value={email} onChange={e => {
                                    setErrors({})
                                    setEmail(e.target.value)
                                }} maxLength={256} className="txt_field mail w-input" />
                                <br />
                                <label htmlFor="name">הקלדת כתובת המייל פעם נוספת</label>
                                <input autoComplete="off" name="email" type="text" value={validateEmail} onChange={e => {
                                    setErrors({})
                                    setValidateEmail(e.target.value)
                                }} maxLength={256} className="txt_field mail w-input" />
                                <div className="form_allert" style={{ display: errors && errors["email"] ? "contents" : "block" }}>{errors["email"]}</div>
                            </div>
                            <input autoComplete="off" disabled={!enabled} type="submit" value={buttonText} data-wait="" className={enabled ? "button_full w-button" : "button_full inactive  w-button"}></input>

                        </div>
                    </form>
                </div>
            </div>
        </>
    )

}

export default EditEmail;

